import POShipmentPreBookingSearchType from './POShipmentPreBookingSearchTypes';

export const getShipmentPreBookingInfoListInProgress = () => {
  return { type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST };
};

export const getShipmentPreBookingInfoListInSuccess = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_SUCCESS,
  };
};

export const getShipmentPreBookingInfoListListInFail = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_FAIL,
  };
};

export const getShipmentPreBookingInfoListListInReset = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST_RESET,
  };
};

export const updateShipmentPreBookingInfoListRequest = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_REQUEST,
  };
};

export const updateShipmentPreBookingInfoCheckedItems = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_CHECKED_ITEMS,
  };
};

export const setShipmentPreBookingSearchExportModal = (payload) => {
  return {
    payload,
    type: POShipmentPreBookingSearchType.SET_SHIPMENT_PRE_BOOKING_SEARCH_EXPORT_TOGGLE,
  };
};
